import React from 'react'
import PropTypes from 'prop-types'
import BureauGrid from './BureauGrid'
import AllReportsTable from './AllReportsTable'
import formatDay from './formatDay'
import { hasUnreportedModel } from './cardModel'
import {
  TITLE,
  LATEST_REPORT,
  REPORT_DATES,
  WHAT_TO_EXPECT,
  EXPECT_PARAGRAPHS,
  SINGLE_REPORT_NOTE,
  ABOUT_TITLE,
  ABOUT_FIRST,
  ABOUT_LAST,
  aboutModels,
} from './copy'

const InfoIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true" className="mt-0.5 shrink-0">
    <circle cx="9" cy="9" r="7.5" fill="none" stroke="var(--color-primary-text)" strokeWidth="1.5" />
    <path d="M9 8v4.5" stroke="var(--color-primary-text)" strokeWidth="1.6" strokeLinecap="round" />
    <circle cx="9" cy="5.5" r="1" fill="var(--color-primary-text)" />
  </svg>
)

const CreditScores = ({ data }) => {
  const multiple = data.reportDayCount > 1
  const chartDrawn = multiple && data.bureaus.some((entry) => entry.showChart)
  const [lead, ...rest] = EXPECT_PARAGRAPHS
  const fine = rest.pop()

  return (
    <div className="grid gap-4">
      <div className="grid gap-1">
        <h2 className="m-0 text-lg-18 font-semibold text-text-primary">{TITLE}</h2>
        <div className="flex flex-wrap gap-x-5 gap-y-0.5 text-[13px] text-text-secondary">
          <span>{LATEST_REPORT} <b className="font-semibold text-text-primary">{formatDay(data.latestReportDay)}</b></span>
          <span>{REPORT_DATES} <b className="font-semibold text-text-primary">{data.reportDayCount}</b></span>
        </div>
      </div>

      <div
        role="note"
        className="flex items-start gap-3 rounded-xl px-4 py-3.5 bg-[color-mix(in_srgb,var(--color-primary-main)_10%,transparent)] dark:bg-[color-mix(in_srgb,var(--color-primary-text)_14%,transparent)]"
      >
        <InfoIcon />
        <div className="grid min-w-0 gap-1.5">
          <p className="m-0 text-md font-semibold text-text-primary">{WHAT_TO_EXPECT}</p>
          {[lead, ...rest].map((text) => (
            <p key={text} className="m-0 text-md text-text-primary">{text}</p>
          ))}
          <p className="m-0 text-[13px] text-text-secondary">{fine}</p>
        </div>
      </div>

      <BureauGrid bureaus={data.bureaus} showChart={multiple} />

      {data.reportDayCount === 1 && <p className="m-0 text-[13px] text-text-secondary">{SINGLE_REPORT_NOTE}</p>}

      {multiple && (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <AllReportsTable rows={data.rows} bureaus={data.bureaus} wide={data.bureaus.length > 1} />
        </div>
      )}

      <div data-testid="about-scores" className="grid gap-1.5">
        <p className="m-0 text-md font-semibold text-text-primary">{ABOUT_TITLE}</p>
        <ul className="m-0 grid list-disc gap-1 pl-[18px] text-[13px] text-text-secondary">
          <li>{ABOUT_FIRST}</li>
          <li>{aboutModels(data.models, hasUnreportedModel(data.bureaus))}</li>
          {chartDrawn && <li>{ABOUT_LAST}</li>}
        </ul>
      </div>
    </div>
  )
}

CreditScores.propTypes = {
  data: PropTypes.object.isRequired,
}

export default CreditScores
